import React, { useEffect, useState } from "react";
import { Container, Grid } from "@material-ui/core";
import PageBreadcrumbs from "../components/Breadcrumbs/PageBreadcrumbs";
import { breadcrumbNode } from "../components/Breadcrumbs/PageBreadcrumbs.d";
import { CriteriasDataGrid } from "../components/CriteriasDataGrid";
import { useGetCriterias } from "../api/replenishmentApi";
import LoadingIndicator from "../components/LoadingIndicator/LoadingIndicator";
import CriteriaEdit from "../components/CriteriaEdit/CriteriaEdit";
import { criteria } from "../api/models/criteria";

const Criterias: React.FC = () => {
	const breadcrumbNodes: breadcrumbNode[] = [{ name: "Min / Max Criterias" }];
	const [{ data: criterias, loading: isSearching }] = useGetCriterias();
	const [ selectedCriteriaId, setSelectedCriteriaId ] = useState();
	const [ selectedCriteria, setSelectedCriteria ] = useState<criteria>();

	useEffect(() => {
		const criteria = criterias?.find(m => m.id === selectedCriteriaId);
		setSelectedCriteria(criteria);
	}, [criterias, selectedCriteriaId]);

	return (
		<Container maxWidth={false}>
			<LoadingIndicator open={isSearching} content="Searching..." />
			<Grid container spacing={6}>
				<Grid container item direction="row">
					<Grid item xs={12} sm={8}>
						<PageBreadcrumbs nodes={breadcrumbNodes} />
					</Grid>
				</Grid>
				<Grid container item direction="row">
					<Grid item xs={12}>
						<CriteriasDataGrid criterias={criterias} onRowsSelected={setSelectedCriteriaId} rowSelection={selectedCriteriaId} />
					</Grid>
				</Grid>
				<Grid container item direction="row">
					<Grid item xs={12}>
						{selectedCriteria && <CriteriaEdit criteria={selectedCriteria} />}
					</Grid>
				</Grid>
			</Grid>
		</Container>
	);
};

export default Criterias;
